import queryOptions from "emun.cust/locations/ship-location-container.query-options";
import templates from "emun.cust/locations/ship-location-container.templates";
import changeStatusOptions from "emun.cust/locations/ship-location.change-status-options";
import customerConfig from "emun.customer/customer.config";
import RetailerShippingLocationPrompt from "emun.retailer/retailer-shipping-location-prompt";
import retailerConfig from "emun.retailer/retailer.config";
import orderConfig from "emun.order/order.config";
import AutoQueryController from "servicestack/auto-query/auto-query.controller";
import addressValidatorPrompt from "webutils/address-validator-prompt";
import CustomerNotesPopup from "emun.customer/customer-notes-popup";
import ContactPopup from "emun.customer/customer-contact.popover";
import RetailerShippingLocationDeletePrompt from "emun.retailer/retailer-shipping-location-delete-prompt";

export default class ShipLocationContainerController extends AutoQueryController {
  constructor() {
    super();
    const $ctrl = this;
    $ctrl.$on("ShippingLocationDeleted", res => {
      $ctrl.load();
    });
  }
  getQuery() {
    const $ctrl = this;
    $ctrl.templates = templates;
    $ctrl.customerConfig = customerConfig;
    $ctrl.config = retailerConfig;
    $ctrl.orderConfig = orderConfig;
    $ctrl.prompt = new RetailerShippingLocationPrompt();
    // console.debug(ShipLocationContainerController.name, $ctrl, arguments);
    return {
      templates,
      criteria: {
        op: ShipLocationContainerController.name,
      },
      ...queryOptions,
      view:
        $ctrl.layout ||
        Object.keys(queryOptions.views)[$ctrl.$pageConfig.is("gt-md") ? 0 : 1],
    };
  }

  newOrder(m) {
    let $ctrl = this;
    $ctrl.$cart.bus.send("QueryRetailers.json?Id=" + m.retailerId).then(function(response) {
      if (response.data.results.length > 0) {
        var retailer = response.data.results[0];
        $ctrl.$cart.createPrompt({
          mode: "Cart",
          status: "Cart",
          retailer: retailer,
          shippingLocation: m,
          email: $ctrl.orderConfig.useShippingLocationEmail ? m.locationEmail : null
        });
      }
    })
  }

  add(retailerId) {
    let $ctrl = this;
    return $ctrl.prompt.add
      .apply($ctrl.prompt, arguments)
      .then(() => $ctrl.query.load(true));
  }

  edit(model = {}) {
    const $ctrl = this;
    const req = Object.assign({}, model, { retailerId: $ctrl.retailerId });
    return $ctrl.prompt.edit(model).then(() => $ctrl.query.load(true));
  }

  delete(model) {
    const $ctrl = this;

    RetailerShippingLocationDeletePrompt.open({ shippingLocation: model }).then(res => {
      //$ctrl.$emit("RetailerShippingLocationDeleted", $ctrl);
      console.debug("BL*** got here");
      $ctrl.load();
    });

    // return $ctrl.$modals
    //   .confirm(
    //     "Are you sure you want to delete shipping location ID: " +
    //       model.id +
    //       " - Name: " +
    //       model.name +
    //       " - Address: " +
    //       model.address +
    //       " " +
    //       model.city +
    //       "?",
    //     "Delete Shipping Location"
    //   )
    //   .result.then(() => {
    //     $ctrl.bus
    //       .send("DeleteRetailerShippingLocation.json", model)
    //       .then(() => {
    //         $ctrl.$emit("RetailerShippingLocationDeleted", $ctrl);
    //         $ctrl.query.load(true);
    //       });
    //   });
  }

  changeStatus(model) {
    const $ctrl = this;
    console.debug("changeStatus", { model, $ctrl });
    return $ctrl.$modals.actions(changeStatusOptions(model)).then((a) => {
      console.debug("SetTaggedStatus/RetailerShippingLocation", a);
      return $ctrl.bus
        .send(
          `SetTaggedStatus/RetailerShippingLocation/${model.id}/${a.status}.json`
        )
        .then(a.handle ? a.handle : $ctrl.query.load.bind($ctrl.query, true));
    });
  }

  validateAddress(location) {
    const $ctrl = this;
    addressValidatorPrompt
      .open({ model: location, key: location.retailerId + location.id })
      .then((address) => {
        if (address.valid && address.selected) {
          $ctrl.query.bus
            .send(
              "QueryRetailerShippingLocations.json?RetailerId=" +
                location.retailerId +
                "&Id=" +
                location.id
            )
            .then((response) => {
              if (response.data.results.length > 0) {
                Object.assign(address.selected, response.data.results[0]);
                $ctrl.query.bus
                  .send("UpdateRetailerShippingLocation", address.selected)
                  .then(() => {
                    $ctrl.query.load(true);
                  });
              }
            });
        }
      });
  }

  customerNotes(location) {
    const $ctrl = this;
    return CustomerNotesPopup({
      customer: {
        id: location.id,
        customerId: location.id,
        companyName: location.name
      },
      locationmode: true,
    });
  }

  contactPopup(customer) {
    const $ctrl = this;
    ContactPopup.open({ customer: customer });
  }

}
